import { createBrowserRouter, Navigate } from 'react-router-dom';

import { Root } from './root';

import { RouteErrorFallback } from '@components/RouteErrorFallback';
import Browse from '@routes/models/browse/Browse';
import Model from '@routes/models/model/Model';
import Upload from './upload/Upload';

export const router = createBrowserRouter([
  { path: '/auth-response', element: <Navigate to="/models" replace /> },
  {
    path: '/',
    element: <Root />,
    errorElement: <RouteErrorFallback />,
    children: [
      { index: true, element: <Navigate to="models" replace /> },
      {
        path: 'models',
        children: [
          { path: '', element: <Navigate to="browse" /> },
          { path: 'browse', element: <Browse /> },
          { path: ':aggregateId', element: <Model /> }
        ]
      },
      { path: 'upload', element: <Upload /> }
    ]
  }
]);
